/**
 * 페이지뷰를 남길 때 필요한 custom_props 를 next.js pages 에서 처리하기 힘들다면 실제 데이터를 핸들링하는 곳에 아래 data-attribute 를 추가합니다
 * {key}={value} 로 넣습니다
 * 예:
 * {...{
 *    [PageViewCustomPropsDataKey.PageDay]: isSelected
 *      ? `page_day=${tabItem.name}`
 *      : undefined,
 *    }
 * }
 */
export enum PageViewCustomPropsDataKey {
  PageDay = 'data-t-pv-cp-page-day',
  PageCategoryFilter = 'data-t-pv-cp-page-category-filter',
  PageGenreFilter = 'data-t-pv-cp-page-genre-filter',
  PageBmFilter = 'data-t-pv-cp-page-bm-filter',
  PageSort = 'data-t-pv-cp-page-sort',
  Completed = 'data-t-pv-cp-page-completed',
  TabType = 'data-t-pv-cp-tab-type',
}
